import { computed, onBeforeUnmount, onMounted, ref, type ComputedRef, type Ref } from "vue";

type CapsLockModifierEvent = KeyboardEvent | MouseEvent;

interface UseDSPasswordFieldCapsLockOptions {
  isEditable: ComputedRef<boolean>;
  isFocused: Ref<boolean>;
}

export const useDSPasswordFieldCapsLock = ({ isEditable, isFocused }: UseDSPasswordFieldCapsLockOptions) => {
  const isCapsLockActive = ref(false);

  const updateCapsLockState = (event: CapsLockModifierEvent) => {
    isCapsLockActive.value = event.getModifierState("CapsLock");
  };

  const isCapsLockHelperTextVisible = computed(() => isEditable.value && isFocused.value && isCapsLockActive.value);

  onMounted(() => {
    window.addEventListener("keydown", updateCapsLockState);
    window.addEventListener("keyup", updateCapsLockState);
    window.addEventListener("mousedown", updateCapsLockState);
  });

  onBeforeUnmount(() => {
    window.removeEventListener("keydown", updateCapsLockState);
    window.removeEventListener("keyup", updateCapsLockState);
    window.removeEventListener("mousedown", updateCapsLockState);
  });

  return {
    isCapsLockHelperTextVisible,
  };
};
